import '../scss/style.scss';

import './script.js';